"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const react_if_1 = require("react-if");
exports.BlockCanvasInputWrapper = (_a) => {
    var { children, unsaved = false } = _a, props = tslib_1.__rest(_a, ["children", "unsaved"]);
    return (react_1.default.createElement(react_2.OsmosysDiv, Object.assign({ osysName: "BlockCanvasWrapper", flexColFilled: true, className: "position-relative" }, props),
        children,
        react_1.default.createElement(react_if_1.When, { condition: !!unsaved },
            react_1.default.createElement(react_2.OsmosysDiv, { className: "position-absolute text-muted small", style: {
                    bottom: 2,
                    left: 5,
                    opacity: 0.4,
                } },
                react_1.default.createElement(react_2.OsmosysIcon, { size: "sm", osysIcon: "spinner", spin: true })))));
};
//# sourceMappingURL=Wrapper.js.map